const GOOGLE_HOSTED_EMAIL_SUFFIXES = ['@gmail.com', '@googlemail.com'] as const;

/** True when the identifier looks like a consumer Google mailbox. */
export function isGoogleHostedEmail(identifier: string): boolean {
  const normalized = identifier.trim().toLowerCase();
  if (!normalized.includes('@')) {
    return false;
  }
  return GOOGLE_HOSTED_EMAIL_SUFFIXES.some((suffix) => normalized.endsWith(suffix));
}
